import { RootState } from '@/store/store';
import { ResultState } from '@/store/types/resultTypes';
import { createSelector } from '@reduxjs/toolkit';

export const selectResult = (state: RootState): ResultState => state.result as ResultState;

export const selectTestId = createSelector(
	[selectResult],
	(resultState) => resultState.resultData.test.id
);
